import React from 'react';
import classes from './LinearGauge.module.scss';
import { ApIcon } from '@alixpartners/ui-components';
import { dataVizColors } from 'styles/colors';

const LinearGauge = props => {
	const { values } = props;
	const { level, min, max, median, clientSpend, group } = values;

	const transformScale = value => {
		if (level !== 1) {
			return ((value - min) / (max - min)) * 100;
		} else {
			return value;
		}
	};

	let showMinWarning,
		showMaxWarning = false;
	let warningTooltip = '';

	const alignCliendIndicator = (
		minValue,
		maxValue,
		clientValue,
		scaledValue
	) => {
		if (clientValue > maxValue) {
			showMaxWarning = true;
			warningTooltip = `Marker value(${clientValue}) is greater than High End(${maxValue})`;
			return 100;
		} else if (clientValue < minValue) {
			warningTooltip = `Marker value(${clientValue}) is lesser than Low End(${min})`;
			showMinWarning = true;
			return 0;
		} else {
			return scaledValue;
		}
	};

	const alignCliendIndicatorLegend = (
		minValue,
		maxValue,
		clientValue,
		scaledValue
	) => {
		if (clientValue > maxValue) {
			return 100 - 1;
		} else if (clientValue < minValue) {
			return 0 + 1;
		} else {
			return scaledValue - 1;
		}
	};

	let scaledClientSpend = Number(transformScale(clientSpend).toFixed(2));
	scaledClientSpend = Math.abs(scaledClientSpend);
	let scaledMedian = Number(transformScale(median).toFixed(2));
	scaledMedian = Math.abs(scaledMedian);

	const isRoot = level === 1 && group === 1;

	return (
		<div className={`${classes.linear_gauge} ${classes.linear_gauge__marker}`}>
			<div
				className={classes.linear_gauge__indicator}
				style={{
					'--custom-marker-position': `${alignCliendIndicator(
						min,
						max,
						clientSpend,
						scaledClientSpend
					)}%`,
					display: `${isRoot && 'none'}`,
				}}
			/>
			<div
				className={classes.linear_gauge__median}
				style={{
					'--custom-median-position': `${scaledMedian}%`,
					display: `${isRoot && 'none'}`,
				}}
			/>
			<div
				className={classes.linear_gauge__spendValue}
				style={{
					'--custom-marker-position': `${alignCliendIndicatorLegend(
						min,
						max,
						clientSpend,
						scaledClientSpend
					)}%`,
					display: `${isRoot && 'none'}`,
				}}
			>
				{clientSpend}
			</div>
			<div
				className={classes.linear_gauge__medianValue}
				style={{
					'--custom-median-position': `${
						scaledMedian === 100 ? 98 : scaledMedian - 1
					}%`,
					display: `${isRoot && 'none'}`,
				}}
			>
				{median}
			</div>
			{showMinWarning && (
				<div
					className={classes.warning_min}
					style={{ display: `${isRoot && 'none'}` }}
				>
					<span title={warningTooltip}>
						<ApIcon
							iconName="outline_error"
							iconSize="24px"
							iconColor={dataVizColors.orange}
						/>
					</span>
				</div>
			)}
			{showMaxWarning && (
				<div
					className={classes.warning_max}
					style={{ display: `${isRoot && 'none'}` }}
				>
					<span title={warningTooltip}>
						<ApIcon
							iconName="outline_error"
							iconSize="24px"
							iconColor={dataVizColors.orange}
						/>
					</span>
				</div>
			)}
		</div>
	);
};

export default LinearGauge;
